import { render, staticRenderFns } from "./EditarEmpresa.vue?vue&type=template&id=83313682&"
import script from "./EditarEmpresa.vue?vue&type=script&lang=js&"
export * from "./EditarEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports